import React, { useState } from "react";
import { FaUpload } from "react-icons/fa6";
import { getExtension } from "../../../../utils/constants";
import { apiErrorMessage } from "../../../../utils/apiErrorCall";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../hooks/reduxDispatch";
import { apiTrainBot } from "../../../../services/apiCalls/user/chatbot";

const FileUpload = () => {
  const inputFileRef = React.useRef();
  const dispatch = useAppDispatch();

  const { singleBotdata } = useAppSelector((s) => s.userBot);

  const [uploadFile, setUploadFile] = React.useState();

  const [status, setStatus] = useState("idle");

  const handleFileDrop = (e) => {
    // Handle file drop
    const file = e?.target?.files[0];
    const fileType = file && getExtension(file?.name).toLowerCase();
    console.log(fileType, "filetype");
    if (
      fileType === "pdf" ||
      fileType === "doc" ||
      fileType === "docx" ||
      fileType === "txt"
    ) {
      const newFileName = singleBotdata?.botId + file.name; // Specify your new file name here

      // Create a new File object with the new name and same content
      const newFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });
      console.log("filetype corr", newFile);
      const formData = new FormData();
      formData.append("file", newFile);

      // console.log(formData.get("file"));
      setStatus("loading");
      dispatch(apiTrainBot(formData, setStatus));
    } else {
      console.log("not correct");
      apiErrorMessage({ message: "Wrong file format " });
    }
  };

  const onBtnClick = () => {
    /*Collecting node-element and performing click*/
    inputFileRef.current.click();
  };

  return (
    <div
      onClick={onBtnClick}
      className="border-2 w-full py-20 border-dashed border-gray-300 rounded p-6 text-center"
    >
      <input
        type="file"
        multiple
        ref={inputFileRef}
        onChange={(e) => handleFileDrop(e)}
        className="hidden"
        placeholder="nope"
      />
      <div className="flex justify-center mb-2">
        <FaUpload />
      </div>
      <p>Drag & drop files here, or click to select files</p>
      <p className="text-sm text-gray-500">
        Supported File Types: .pdf, .doc, .docx, .txt
      </p>
    </div>
  );
};

export default FileUpload;
